import * as React from "react"

import { cn } from "@/lib/utils"

// 🔢 Number inputs keep the raw text while focused (decimal point isn't eaten by
// parseFloat-on-change parents, field can be cleared); parent value re-syncs on blur.
// Scroll wheel is ignored to avoid accidental value changes.
const Input = React.forwardRef(({ className, type, value, onChange, onFocus, onBlur, ...props }, ref) => {
  const isNum = type === "number";
  const [draft, setDraft] = React.useState(null);
  const controlled = value !== undefined;
  const display = isNum && draft !== null ? draft : value;
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
      {...(controlled ? { value: display ?? "" } : {})}
      onChange={(e) => { if (isNum) setDraft(e.target.value); onChange && onChange(e); }}
      onFocus={(e) => { if (isNum && controlled) setDraft(e.target.value); onFocus && onFocus(e); }}
      onBlur={(e) => { if (isNum) setDraft(null); onBlur && onBlur(e); }}
      onWheel={(e) => { if (isNum) { e.currentTarget.blur(); } props.onWheel && props.onWheel(e); }}
    />
  );
})
Input.displayName = "Input"

export { Input }
